import { useContext } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormCheckboxType } from './type'
import { Checkbox } from '@/components/ui/checkbox'

export const FormCheckboxField = ({
  data,
  field,
}: FormFieldProps<FormCheckboxType>) => {
  const context = useContext(FormContext)

  return (
    <div className="flex py-1">
      <Checkbox
        disabled={data.readOnly}
        checked={field.value}
        onCheckedChange={field.onChange}
        className="size-4"
      />
    </div>
  )
}
